<template>
  <input class="StdInput" :value="value" :type="type" :placeholder="placeholder" @input="onChange(name, $event)" />
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: "text",
    },
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: "",
    },
    onChange: {
      type: Function,
      default() {},
    },
  },
}
</script>

<style scoped>
.StdInput {
  border: none;
  border-radius: 3px;
  box-shadow: 0 2px 4px 3px rgba(0,0,0,0.2);
  color: #b8c1cf;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 0.9em;
  line-height: 32px;
  margin: 0;
  margin-bottom: 26px;
  padding: 5px 10px;
  transition: all 0.2s;
}

.StdInput:focus {
  box-shadow: 0 2px 8px 8px rgba(0,0,0,0.1);
  color: #3c4148;
  outline: none;
  transform: scale(1.1, 1.1);
}
</style>





// WEBPACK FOOTER //
// src/components/StdInput/StdInput.vue